const json = {
    name: 'root',
    isFolder: true,
    items: [
        {
            name: 'Public',
            isFolder: true,
            items: [
                {
                    name: 'index.js',
                    isFolder: false,
                },
                {
                    name: 'index.html',
                    isFolder: false,
                }
            ]
        },
        {
            name: 'src',
            isFolder: true,
            items: [
                {
                    name: 'components',
                    isFolder: true,
                    items:[
                        {
                            name: 'TopBar.js',
                            isFolder: false,
                        },
                        {
                            name: 'RowContainer.js',
                            isFolder: false,
                        },
                        {
                            name: 'SideBar.js',
                            isFolder: false,
                        },
                        {
                            name: 'MuiCard.js',
                            isFolder: false,
                        },
                        {
                            name: 'Footer.js',
                            isFolder: false,
                        },
                        {
                            name: 'index.js',
                            isFolder: false,
                        },
                    ]
                },
                {
                    name: 'index.js',
                    isFolder: false,
                },
                {
                    name: 'app.js',
                    isFolder: false,
                },
                {
                    name: 'package.json',
                    isFolder: false,
                }
            ]
        }
    ]
};
export default json;